export const RESET = 'EXCMAGREEMENTTYPE_LIST_RESET'
export const SET_ITEMS = 'EXCMAGREEMENTTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMAGREEMENTTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMAGREEMENTTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMAGREEMENTTYPE_LIST_TOGGLE_LOADING'
